import {
  getVetFormLink as axiosGetVetFormLink, // getVeterinarioById as axiosGetVeterinarioById,
  // getVeterinarioByVetForm as axiosGetVeterinarioByVetForm,
  // getVeterinarios as axiosGetVeterinarios,
  // getVeterinariosBySiniestro as axiosGetVeterinariosBySiniestro,
  // getVeterinariosRecomendados as axiosGetVeterinariosRecomendados,
  postVetFormLink as axiosPostVetFormLink,
  reSendVetFormLink as axiosReSendVetFormLink,
} from '../../axios/Reintegro/Veterinario';
import { VetFormLinkData } from '../../types/Reintegro/Veterinario/types';
import { useCreateEntity } from '../Utils/useEntity';

const usePostVetFormLink = () => {
  const { create, isLoading, error } = useCreateEntity<
    VetFormLinkData,
    { ok: boolean; data?: boolean }
  >(async (vetFormLink) => {
    const response = await axiosPostVetFormLink(vetFormLink);

    return {
      ok: response.success,
      data: response.success,
    };
  });

  return { postVetFormLink: create, isLoading, error };
};

const useReSendVetFormLink = () => {
  const { create, isLoading, error } = useCreateEntity<
    {
      vetFormLinkData: VetFormLinkData;
      subVetFormId: number;
    },
    { ok: boolean; data?: boolean }
  >(async ({ vetFormLinkData, subVetFormId }) => {
    const response = await axiosReSendVetFormLink({
      vetFormLinkData,
      subVetFormId,
    });

    return {
      ok: response.success,
      data: response.success,
    };
  });

  return { reSendVetFormLink: create, isLoading, error };
};

/**
 * Hook para obtener datos del VetFormLink de forma manual (lazy)
 */
const useLazyGetVetFormLink = () => {
  const fetchVetFormLink = async (ref: string) => {
    const res = await axiosGetVetFormLink(ref);
    return res.success ? res.data : undefined;
  };

  return { fetchVetFormLink };
};

// const useGetVeterinarios = () =>
//   useFetchEntity('veterinarios', async () => {
//     const res = await axiosGetVeterinarios();
//     return res.success ? res.data : undefined;
//   });

// const useGetVeterinarioById = (id: string) =>
//   useFetchEntity('veterinarioById', async () => {
//     const res = await axiosGetVeterinarioById(id);
//     return res.success ? res.data : undefined;
//   });

// const useGetVeterinariosBySiniestro = (siniestro: string) =>
//   useFetchEntity('veterinariosBySiniestro', async () => {
//     const res = await axiosGetVeterinariosBySiniestro(siniestro);
//     return res.success ? res.data : undefined;
//   });

// const useGetVeterinarioByVetform = (vetFormId: string) =>
//   useFetchEntity('veterinarioByVetform', async () => {
//     const res = await axiosGetVeterinarioByVetForm(vetFormId);
//     return res.success ? res.data : undefined;
//   });

// const useGetVeterinariosRecomendados = (id: number, tipo: string) =>
//   useFetchEntity('veterinariosRecomendados', async () => {
//     const res = await axiosGetVeterinariosRecomendados(id, tipo);
//     return res.success ? res.data : undefined;
//   });

export {
  usePostVetFormLink,
  useReSendVetFormLink,
  useLazyGetVetFormLink,
  // useGetVeterinarios,
  // useGetVeterinarioById,
  // useGetVeterinariosBySiniestro,
  // useGetVeterinarioByVetform,
  // useGetVeterinariosRecomendados,
};
